import { Base } from '@studiometa/js-toolkit';

/**
 * ProductShopLookSlider - Flèches de navigation de la liste des produits du look en mobile
 *
 * La liste reste un défilement horizontal natif (scroll-snap) : les flèches font
 * défiler la piste d'une carte et sont désactivées aux extrémités. La navigation
 * est masquée lorsque la piste ne déborde pas (desktop, ou peu de produits).
 */
export default class ProductShopLookSlider extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'ProductShopLookSlider',
    refs: ['track', 'items[]', 'nav', 'prev', 'next'],
  };

  /**
   * Mounted hook
   */
  mounted() {
    this.updateNav();
  }

  /**
   * Resized hook
   */
  resized() {
    this.updateNav();
  }

  /**
   * Met à jour l'état des flèches au défilement de la piste
   */
  onTrackScroll() {
    this.updateNav();
  }

  /**
   * Fait défiler vers la carte précédente
   */
  onPrevClick() {
    this.scrollByItem(-1);
  }

  /**
   * Fait défiler vers la carte suivante
   */
  onNextClick() {
    this.scrollByItem(1);
  }

  /**
   * Fait défiler la piste de la largeur d'une carte (gouttière comprise)
   * @param {number} direction 1 pour suivant, -1 pour précédent
   */
  scrollByItem(direction) {
    const { track, items } = this.$refs;

    if (!track) {
      return;
    }

    const [first, second] = items;
    const step =
      first && second
        ? second.offsetLeft - first.offsetLeft
        : (first?.offsetWidth ?? track.clientWidth);

    track.scrollBy({ left: step * direction, behavior: 'smooth' });
  }

  /**
   * Affiche ou masque la navigation et désactive les flèches aux extrémités
   */
  updateNav() {
    const { track, nav, prev, next } = this.$refs;

    if (!track) {
      return;
    }

    const maxScroll = track.scrollWidth - track.clientWidth;
    // Tolérance d'un pixel pour les arrondis de positions sub-pixel.
    const isScrollable = maxScroll > 1;

    if (nav) {
      nav.classList.toggle('hidden', !isScrollable);
    }

    if (prev) {
      prev.disabled = !isScrollable || track.scrollLeft <= 1;
    }

    if (next) {
      next.disabled = !isScrollable || track.scrollLeft >= maxScroll - 1;
    }
  }
}
